import { Animation, AnimationController } from '@ionic/angular';
import { trigger, transition, style, animate, state, query, stagger } from '@angular/animations';

const animationCtrl = new AnimationController();


	  export const listAnimation = trigger('listAnimation', [
		transition(':increment', [
		  query(':enter', [
			style({ 
			  opacity: 0, 
			  transform: ' rotateX(20deg) translateY(75%) scale(1.4)', 
			  'transform-origin': 'top' 
			}),
			stagger(50, [
			  animate('300ms ease-in-out', style({ 
				opacity: 1, 
				transform: ' rotateX(0deg) translateY(0) scale(1)' 
			  }))
			])
		  ], { optional: true }),
		  query(':leave', [
			style({ 
			  opacity: 1, 
			  transform: ' rotateX(0deg) translateY(0) scale(1)' 
			}),
			// stagger(50, [
			animate('300ms ease-in-out', style({ 
			  opacity: 0, 
			  transform: ' rotateX(15deg) translateY(-50%) scale(0.8)' 
			}))
		// ])
		  ], { optional: true })
		]),
	  
		transition(':decrement', [
		  query(':enter', [
			style({ 
			  opacity: 0, 
			  transform: ' rotateX(20deg) translateY(75%) scale(1.4)', 
			  'transform-origin': 'bottom' 
			}),
			stagger(100, [
			  animate('300ms ease-in-out', style({ 
				opacity: 1, 
				transform: ' rotateX(0deg) translateY(0) scale(1)' 
			  }))
			])
		  ], { optional: true }),
		  query(':leave', [
			style({ 
			  opacity: 1, 
			  transform: ' rotateX(0deg) translateY(0) scale(1)' 
			}),
			// stagger(50, [
			animate('300ms ease-in-out', style({ 
			  opacity: 0, 
			  transform: ' rotateX(-15deg) translateY(-50%) scale(0.8)' 
			}))
		// ])
		  ], { optional: true })
		])
	  ]);

	  export const calAnimate = trigger('calAnimate', [
		transition('* <=> *', [
		  query(':enter', [
			style({ 
			  opacity: 0, 
			  transform: 'rotateX(45deg) translateY(25%) scale(2.5)' 
			//   'transform-origin': 'top' 
			}),
			stagger(50, [
			  animate('300ms ease-in-out', style({ 
				opacity: 1, 
				transform: 'rotateX(0deg) translateY(0) scale(1)' 
			  }))
			])
		  ], { optional: true }),
		  query(':leave', [
			style({ 
			  opacity: 1,
			  transform: 'rotateX(0deg) translateY(0) scale(1)' 
			}),
			// stagger(50, [
			animate('300ms ease-in-out', style({ 
			  opacity: 0,
			  transform: 'rotateX(0deg) translateY(0%) scale(1)' 
			}))
		// ])
		  ], { optional: true })
		]),
	  
		// transition(':decrement', [
		//   query(':enter', [
		// 	style({ 
		// 	  opacity: 0, 
		// 	  transform: ' rotateX(20deg) translateX(75%) scale(1.4)', 
		// 	  'transform-origin': 'bottom' 
		// 	}),
		// 	stagger(100, [
		// 	  animate('300ms ease-in-out', style({ 
		// 		opacity: 1, 
		// 		transform: ' rotateX(0deg) translateX(0) scale(1)' 
		// 	  }))
		// 	])
		//   ], { optional: true }),
		//   query(':leave', [
		// 	style({ 
		// 	  opacity: 1, 
		// 	  transform: ' rotateX(0deg) translateX(0) scale(1)' 
		// 	}),
		// 	// stagger(50, [
		// 	animate('300ms ease-in-out', style({ 
		// 	  opacity: 0, 
		// 	  transform: ' rotateX(-15deg) translateX(-50%) scale(0.8)' 
		// 	}))
		// // ])
		//   ], { optional: true })
		// ])
	  ]);

	  export const slideAnimation = trigger('slideAnimation', [
		transition(':enter', [
		  query('.cardItem', [
			style({ 
			  opacity: 0, 
			  transform: 'translateX(20vh) scale(1.5)', 
			  'transform-origin': 'top' 
			}),
			stagger(50, [
			  animate('300ms ease-in-out', style({ 
				opacity: 1, 
				transform: 'translateX(0) scale(1)' 
			  }))
			])
		  ], { optional: true })
		]),
	  
		transition(':leave', [
		  query('.cardItem', [
			stagger(50, [
			  animate('300ms ease-in-out', style({ 
				opacity: 0, 
				transform: 'translateX(-20vh) scale(0.8)' 
			  }))
			])
		  ], { optional: true })
		])
	  ]);

	  export const viewTransition = trigger('viewTransition', [
		// Fade-in transition
		transition(':enter', [
		  style({ opacity: 0 }),
		  animate('500ms 0s', style({ opacity: 1 }))
		]),
		
		// Fade-out transition
		transition(':leave', [
		  style({ opacity: 1 }),
		  animate('500ms 0s', style({ opacity: 0 }))
		])
	  ]);
	  
	  


export const selectAnimation = trigger('selectAnimation', [
	state('unselected-food', style({
        // No specific styles for inactive state
      })),
      state('selected-food', style({
        // No specific styles for active state
      })),
	  transition('unselected-food => selected-food', [
		animate('0.3s 0.2s ease-in-out', style({ borderRadius: '*' })),  // Border-radius transition
		animate('0.3s ease-in-out', style({ height: '*' })),              // Height transition
		animate('0.3s 0.1s ease-in-out', style({ backgroundColor: '*' })) // Background-color transition
	  ]),
	  transition('selected-food => unselected-food', [
		animate('0.3s 0.2s ease-in-out', style({ borderRadius: '*' })),  
		animate('0.3s ease-in-out', style({ height: '*' })),             
		animate('0.3s 0.1s ease-in-out', style({ backgroundColor: '*' })) 
	  ])
]);
export const getIonPageElement = (element: HTMLElement | null): HTMLElement => {
	if (!element) {
	  console.error('Element is null or undefined');
	  return element as HTMLElement;  // Type assertion to HTMLElement if null
	}
  
	if (element.classList.contains('ion-page')) {
	  return element;
	}
  
	const ionPage = element.querySelector(
	  ':scope > .ion-page, :scope > ion-nav, :scope > ion-tabs'
	) as HTMLElement;  // Ensure querySelector returns HTMLElement
	if (ionPage) {
	  return ionPage;
	}
  
	return element;
  };
export const pageTransition2 = (baseEl: HTMLElement, opts: any, animationCtrl: AnimationController) => {
	const backDirection = opts.direction === 'back';
	const enteringEl = opts.enteringEl;
	const leavingEl = opts.leavingEl;
  
	const enteringPageEl = getIonPageElement(enteringEl); // Ensure this function is available
	const leavingPageEl = getIonPageElement(leavingEl); // Ensure this function is available
  
	const rootTransition = animationCtrl.create();
  
	const enterTransition = animationCtrl.create();
	const leavingTransition = animationCtrl.create();
  
	// Transition for the leaving element
	leavingTransition.addElement(leavingPageEl).duration(600);
  
	// Transition for the entering element
	enterTransition
	  .addElement(enteringPageEl)
	  .duration(600)
	  .fill('both')
	  .beforeRemoveClass('ion-page-invisible');
  
	if (!backDirection) {
	  // Forward transition (non-back)
	  enterTransition
		.beforeStyles({ border: 'thin solid transparent' })
		.keyframes([
		  { offset: 0, transform: 'scale(1.2)' },
		  { offset: 1, transform: 'scale(1)' }
		])
		.afterClearStyles(['border']);
  
	  leavingTransition
		.keyframes([
		  { offset: 0, opacity: 1 },
		  { offset: 1, opacity: 0.1 }
		]);
	} else {
	  // Backward transition (back)
	  enterTransition
		.keyframes([
		  { offset: 0, opacity: 0.1 },
		  { offset: 1, opacity: 1 }
		]);
  
	  leavingTransition
		.beforeStyles({ border: 'thin solid transparent' })
		.keyframes([
		  { offset: 0, transform: 'scale(1)' },
		  { offset: 1, transform: 'scale(1.2)' }
		])
		.afterClearStyles(['border']);
	}
  
	rootTransition.addAnimation([enterTransition, leavingTransition]);
  
	return rootTransition;
  };
export const pageTransition = (baseEl: HTMLElement, opts?: any): Animation => {
    const DURATION = 500; // Duration of the transition in milliseconds
    const EASING = 'ease-in-out'; // Smooth easing function for the transition

    // Forward direction animation (navigating to a new page)
    if (opts.direction === 'forward') {
		const enteringAnimation = animationCtrl.create()
            .addElement(opts.enteringEl)
            .duration(DURATION)
            .easing(EASING)
            .keyframes([
                { offset: 0, opacity: '0', transform: 'scale(0.9)' },
                { offset: 0.5, opacity: '0.5', transform: 'scale(0.95)' },
                { offset: 1, opacity: '1', transform: 'scale(1)' },
            ]);
			const leavingAnimation = animationCtrl.create()
            .addElement(opts.leavingEl)
            .duration(DURATION)
            .easing(EASING)
            .keyframes([
                { offset: 0, opacity: '1', transform: 'scale(1)' },
                { offset: 0.5, opacity: '0.5', transform: 'scale(0.95)' },
                { offset: 1, opacity: '0', transform: 'scale(0.9)' },
            ]);
			return animationCtrl.create().addAnimation([enteringAnimation, leavingAnimation]);
    } 
    // Backward direction animation (navigating back to the previous page)
    else {
        const enteringAnimation = animationCtrl.create()
            .addElement(opts.enteringEl)
            .duration(DURATION)
            .easing(EASING)
            .keyframes([
                { offset: 0, opacity: '0', transform: 'scale(0.9)' },
                { offset: 0.5, opacity: '0.5', transform: 'scale(0.95)' },
                { offset: 1, opacity: '1', transform: 'scale(1)' },
            ]);

        const leavingAnimation = animationCtrl.create()
            .addElement(opts.leavingEl)
            .duration(DURATION)
            .easing(EASING)
            .keyframes([
                { offset: 0, opacity: '1', transform: 'scale(1)' },
                { offset: 0.5, opacity: '0.5', transform: 'scale(0.95)' },
                { offset: 1, opacity: '0', transform: 'scale(0.9)' },
            ]);

        return animationCtrl.create().addAnimation([enteringAnimation, leavingAnimation]);
    }
};
export const customAlertEnter = (baseEl: HTMLElement, opts?: any): Animation => {
	const DURATION = 600;
	//console.log('baseEl: ', baseEl);
	//console.log('opts: ', opts);

	const backdropAnimation = animationCtrl.create()
		.addElement(baseEl.querySelector('ion-backdrop'))
		.fromTo('opacity', 0.01, 0);

	const wrapperElem = baseEl.querySelector('.alert-wrapper') as HTMLElement;
	wrapperElem.style.top = '0';
	const wrapperAnimation = animationCtrl.create()
		.addElement(wrapperElem)
		.beforeStyles({ 'opacity': 1 })
		.fromTo('transform', `translateY(-${baseEl.clientHeight}px)`, 'translateY(0px)');

	return animationCtrl.create()
		.addElement(baseEl)
		.easing('ease-in-out')
		.duration(DURATION)
		.addAnimation([backdropAnimation, wrapperAnimation]);
}
export const customAlertLeave = (baseEl: HTMLElement, opts?: any): Animation => {
	const DURATION = 600;
	//console.log('baseEl: ', baseEl);
	//console.log('opts: ', opts);

	const backdropAnimation = animationCtrl.create()
		.addElement(baseEl.querySelector('ion-backdrop'))
		.fromTo('opacity', 0.01, 0);

	const wrapperElem = baseEl.querySelector('.alert-wrapper') as HTMLElement;
	wrapperElem.style.top = '0';
	const wrapperAnimation = animationCtrl.create()
		.addElement(wrapperElem)
		.beforeStyles({ 'opacity': 1 })
		.fromTo('transform', 'translateY(0px)', `translateY(${baseEl.clientHeight}px)`);

	return animationCtrl.create()
		.addElement(baseEl)
		.easing('ease-in-out')
		.duration(DURATION)
		.addAnimation([backdropAnimation, wrapperAnimation]);
}
export const customLoaderEnter = (baseEl: HTMLElement, opts?: any): Animation => {
	const DURATION = 600;
	//console.log('baseEl: ', baseEl);
	//console.log('opts: ', opts);

	const backdropAnimation = animationCtrl.create()
		.addElement(baseEl.querySelector('ion-backdrop'))
		.fromTo('opacity', 0.01, 0);

	const wrapperElem = baseEl.querySelector('.loading-wrapper') as HTMLElement;
	wrapperElem.style.top = '0';
	const wrapperAnimation = animationCtrl.create()
		.addElement(wrapperElem)
		.beforeStyles({ 'opacity': 1 })
		.fromTo('transform', `translateY(-${baseEl.clientHeight}px)`, 'translateY(0px)');

	return animationCtrl.create()
		.addElement(baseEl)
		.easing('ease-in-out')
		.duration(DURATION)
		.addAnimation([backdropAnimation, wrapperAnimation]);
}
export const customLoaderLeave = (baseEl: HTMLElement, opts?: any): Animation => {
	const DURATION = 600;
	//console.log('baseEl: ', baseEl);
	//console.log('opts: ', opts);

	const backdropAnimation = animationCtrl.create()
		.addElement(baseEl.querySelector('ion-backdrop'))
		.fromTo('opacity', 0.01, 0);

	const wrapperElem = baseEl.querySelector('.loading-wrapper') as HTMLElement;
	wrapperElem.style.top = '0';
	const wrapperAnimation = animationCtrl.create()
		.addElement(wrapperElem)
		.beforeStyles({ 'opacity': 1 })
		.fromTo('transform', 'translateY(0px)', `translateY(${baseEl.clientHeight}px)`);

	return animationCtrl.create()
		.addElement(baseEl)
		.easing('ease-in-out')
		.duration(DURATION)
		.addAnimation([backdropAnimation, wrapperAnimation]);
}
export const customModalEnter = (baseEl: HTMLElement, opts?: any): Animation => {
	const DURATION = 600;
	/*console.log('baseEl: ', baseEl);
	console.log('opts: ', opts);*/

	const backdropAnimation = animationCtrl.create()
		.addElement(baseEl.shadowRoot.querySelector('ion-backdrop')!)
		.fromTo('opacity', '0.01', '0');

	const wrapperAnimation = animationCtrl.create()
		.addElement(baseEl.shadowRoot.querySelector('.modal-wrapper')!)
		.keyframes([
			{ offset: 0, opacity: '0', transform: 'scale(0.8)' },
			{ offset: 1, opacity: '0.99', transform: 'scale(1)' },
		]);

	return animationCtrl.create()
		.addElement(baseEl)
		// .easing('ease-in-out')
		// .easing('cubic-bezier(0.25, 1.5, 0.5, 1)')
		.easing('cubic-bezier(0.68, -0.55, 0.27, 1.55)')
		.duration(DURATION)
		.addAnimation([backdropAnimation, wrapperAnimation]);
}
export const customModalLeave = (baseEl: HTMLElement): Animation => {
	return customModalEnter(baseEl).direction('reverse');
}

// export const initListAnimation = (baseEl: HTMLElement): Animation => {
// 	const DURATION = 600;
// 	//console.log('baseEl: ', baseEl);
// 	//console.log('opts: ', opts);

// 	const backdropAnimation = animationCtrl.create()
// 		.addElement(baseEl.querySelector('ion-backdrop'))
// 		.fromTo('opacity', 0.01, 0);

// 	const wrapperElem = baseEl.querySelector('.alert-wrapper') as HTMLElement;
// 	wrapperElem.style.top = '0';
// 	const wrapperAnimation = animationCtrl.create()
// 		.addElement(wrapperElem)
// 		.beforeStyles({ 'opacity': 1 })
// 		.fromTo('transform', `translateY(-${baseEl.clientHeight}px)`, 'translateY(0px)');

// 	return animationCtrl.create()
// 		.addElement(baseEl)
// 		.easing('ease-in-out')
// 		.duration(DURATION)
// 		.addAnimation([backdropAnimation, wrapperAnimation]);
// }